module.exports = __webpack_public_path__ + "d4dfc87a5a68f887bd679b9bd0bc1020.jpg";